import { IFeaturedShiftsCampaign } from 'models/FeaturedShiftsCampaign'
import { action, payload } from 'ts-action'

export const FeaturedShiftsCampaignsFetching = action(
  'FeaturedShiftsCampaignsFetching',
  payload<boolean>(),
)
export const GetFeaturedShiftsCampaign = action(
  'GetFeaturedShiftsCampaign',
  payload<IFeaturedShiftsCampaign>(),
)
export const ClearFeaturedShiftsCampaignReducer = action(
  'ClearFeaturedShiftsCampaignReducer',
)
